var React = require('react');

function Readmore (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.0768 10.6313V15.2869L8.06006 16.4491L6.04333 17.6113L4.02661 18.7734L2.01672 19.9356V19.9425L0 21.1046V16.4491L2.01672 15.2869L4.02661 14.1247L6.04333 12.9625L8.06006 11.8004V11.7935L10.0768 10.6313Z","fill":"#FFCC00","key":0}),React.createElement("path",{"d":"M10.0768 5.98461V10.6333L8.06006 9.47115L6.04333 8.30896L4.02661 7.14679L2.01672 5.98461L0 4.82243V0.16687L2.01672 1.32905L4.02661 2.49123L6.04333 3.65341L8.06006 4.82243L10.0768 5.98461Z","fill":"#FFCC00","key":1})]);
}

Readmore.defaultProps = {"width":"11","height":"22","viewBox":"0 0 11 22","fill":"none"};

module.exports = Readmore;

Readmore.default = Readmore;
